import { Route, Routes } from "react-router-dom";
import PageNotFound from "components/base/PageNotFound";
import ModelView from "./3d";
import Google from "./google";
import InvoiceVerify from "./invoice-verify";
import PackageTracking from "./package";
import PackageDestination from "./package/PackageDestination";
import PackageInfo from "./package/PackageInfo";
import QRCodePage from "./QRCodePage";
import ShortLinks from "./shortlinks";
import ShopifyAlcOrdersPage from "./shopify-alc";
import SystemTasksPage, { SystemTaskDetail } from "./systemTasks";

function ToolsIndex() {
  return (
    <Routes>
      <Route>
        <Route path="shopify-alc" element={<ShopifyAlcOrdersPage />} />
        <Route path="shortlinks" element={<ShortLinks />} />
        <Route path="qrcode" element={<QRCodePage />} />
        <Route path="google" element={<Google />} />
        <Route path="package" element={<PackageTracking />} />
        <Route path="package/:packageId" element={<PackageInfo />} />
        <Route path="package/destination" element={<PackageDestination />} />
        <Route path="3d" element={<ModelView />} />
        <Route path="invoice-verify" element={<InvoiceVerify />} />
        <Route path="system-tasks" element={<SystemTasksPage />} />
        <Route path="system-tasks/:id" element={<SystemTaskDetail />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
}

export default ToolsIndex;
